import { Directive, ElementRef, HostListener, inject } from '@angular/core';

@Directive({
  selector: '[appBlurOnClick]',
  standalone: true,
})
export class BlurOnClickDirective {
  elementRef = inject(ElementRef);

  @HostListener('click')
  onClick(): void {
    this.elementRef.nativeElement.blur();
  }
}
